export default "__VITE_ASSET__b579f0f6__"